export default __webpack_public_path__ + "images/c8d5216b246a1632c681b7a725ff73d6.png";